import React, { useEffect } from 'react';
import ServiceCard from '../../Components/ServiceCard';
// import services from '../../data/ServicesSectionData/whatWeOfferData';
import AOS from "aos";
import "aos/dist/aos.css";
import services from '../../data/LandingSectionData/techSolutions';
import TechServiceCard from '../../Components/TechServiceCard';

const WhatWeOffer = () => {

      useEffect(() => {
    AOS.init();
  }, []);


  return (
    <section className="bg-bgDefault text-white px-5 py-6 lg:px-4 lg:py-5">
      <div className="container xl:mx-auto xl:max-w-screen-xl">
        {/* <h2 className="text-heading-4 md:text-heading-1 font-dmsans font-bold tracking-[-0.06em]  mb-10"  data-aos="fade-right">What We Offer</h2> */}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" >
          {/* {services.map((service, index) => (
          <div
            key={index}
            data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="1000"
            data-aos-delay={index * 200} 
          >
            <ServiceCard
              image={service.image}
              title={service.title}
              desc={service.desc}
            />
          </div>
        ))} */}

        {services.map((service, index) => (
            // <TechServiceCard
            //   key={index}
            //   image={service.image}
            //   name={service.name}
            //   index={index}
            // />

            <ServiceCard
              image={service.image}
              title={service.name}
              desc={service.desc?service.desc:"We provide top-notch services to elevate your business."}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeOffer;
